import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Part2Checker from '../../Components/Part2.component';
import DownIcon from '../../Visuals/Icons/ChevronDown.icon';

const CourseDescription = ({ course }) => {
  const [showIndustries, setShowIndustries] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const showIndustriesHandler = () => {
    setShowIndustries((prev) => !prev);
  };
  const showDescriptionHandler = () => {
    setShowDescription((prev) => !prev);
  };
  return (
    <>
      <div className="courseTop">
        <h2>{course?.courseName}</h2>
        <h3>${course?.price}</h3>
      </div>
      <div className="courseMiddle">
        <>
          {course?.expiryDate >= 0 ? (
            <p className="expiryDate m1B ">
              Expires in:{'  '}
              <span className="italicSpan">
                {'  '} {course?.expiryDate} years{' '}
              </span>
            </p>
          ) : (
            <p className="expiryDate">Course does not expire</p>
          )}
        </>
        <div className="courseDescription">
          <p>{course?.description}</p>
        </div>
        <div>
          <div className="spaceBetween greyBorder m1B m1T">
            <h4>Course Overview</h4>
            <DownIcon functionName={showDescriptionHandler} />
          </div>
          {showDescription && (
            <>
              <p>
                With each course you will start with a detailed PowerPoint
                presentation that provides the information needed. Alongside the
                presentation, you will have videos and documentation (depending
                on the course) that dives more into the subject matter. After
                reviewing the course material, you will be able to take a quiz
                to test your knowledge. To pass the quiz you must get 85% or
                higher. If you do not pass the quiz, you will have the
                opportunity to take the quiz as many times as needed. Upon
                passing the quiz, you will receive a certificate of completion
                that you can download and access at any time through your
                profile.
              </p>
              <p className="expiryDate m1B m1T">
                Time Length:{' '}
                <span className="italicSpan">Approximately 1 to 4 hours</span>
              </p>
              <p>
                If you have any questions about this course or need assistance,
                contact us at yodasafetyservices1@outlook.com
              </p>
            </>
          )}
        </div>
        {/* <p>{course?.notes}</p> */}
        <div className="industries">
          <div className="spaceBetween greyBorder m1B m1T">
            <h4>Industries</h4>
            <DownIcon functionName={showIndustriesHandler} />
          </div>
          {showIndustries && (
            <ul>
              {course?.tags?.map((tag, index) => (
                <li key={index}>{tag}</li>
              ))}
            </ul>
          )}
        </div>
        <Part2Checker course={course} />
      </div>
    </>
  );
};

CourseDescription.propTypes = {
  course: PropTypes.shape({
    courseName: PropTypes.string,
    price: PropTypes.number,
    description: PropTypes.string,
    notes: PropTypes.string,
    expiryDate: PropTypes.number,
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default CourseDescription;
